import * as Yup from "yup";

const cooksSchema = Yup.object().shape({
  cuisine: Yup.string()
    .required("Please select a cuisine")
    .max(50, "Cuisine must be less than 50 characters")
    .matches(/^[a-zA-Z\s]+$/, "Cuisine must contain only letters and spaces")
    .transform((value) => value?.trim()),

  vegNonVeg: Yup.string()
    .required("Please select Veg or Non-Veg")
    .oneOf(["Veg", "Non-Veg"], "Please select a valid option"),

  people: Yup.number()
    .required("Please enter number of people")
    .typeError("People must be a number")
    .positive("Must be a positive number")
    .min(1, "At least 1 person required")
    .max(50, "Maximum 50 people allowed"),

  allergies: Yup.string()
    .required("Please select if allergies are present")
    .oneOf(["Yes", "No"], "Please select a valid option"),

  allergyDetails: Yup.string()
    .when("allergies", {
      is: "Yes",
      then: (schema) => schema
        .required("Please specify the allergies")
        .max(500, "Allergy details must be less than 500 characters")
        .transform((value) => value?.replace(/\s+/g, " ").trim()),
      otherwise: (schema) => schema.notRequired(),
    }),

  diet: Yup.string()
    .required("Please enter diet/menu preferences")
    .max(500, "Diet preferences must be less than 500 characters")
    .transform((value) => value?.replace(/\s+/g, " ").trim()),

  providingRecipe: Yup.string()
    .required("Please specify if you are providing a recipe")
    .oneOf(["Yes", "No"], "Please select a valid option"),

  menuDetails: Yup.string()
    .when("providingRecipe", {
      is: "Yes",
      then: (schema) => schema
        .required("Please provide menu/recipe details")
        .max(1000, "Menu details must be less than 1000 characters")
        .transform((value) => value?.replace(/\s+/g, " ").trim()),
      otherwise: (schema) => schema.notRequired(),
    }),
});

export default cooksSchema;
